export enum EditorEntityKind {
  formField = 'FORM_FIELD',
}
